import axios from 'axios'

const debug = process.env.NODE_ENV !== 'production'

export const getApiClient = (apiUrl, config) => {
  const apiClient = axios.create({
    baseURL: apiUrl,
    ...config
  })

  apiClient.interceptors.response.use(
    function (response) {
      if (debug) {
        console.log('Response:', response)
      }
      return response
    },
    function (error) {
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data)
      }
      return Promise.reject(error.message)
    }
  )

  apiClient.interceptors.request.use(function (config) {
    if (debug) {
      console.log('Request:', config)
    }
    return config
  })

  return apiClient
}

const ccApiClient = getApiClient(
  process.env.VUE_APP_API_HOST,
  {
    headers: {
      'Accept-Language': 'en'
    }
  }
)

export default ccApiClient
